@if ($loadingSports | async) {
  <app-nav-item-loader [show]="true" />
}
<ul class="markets-list list-unstyled">
  @for (parent of parents; track $index) {
    @let isEvent = parent.type === "EVENT";
    @let outletNavigation = [parent.type.toLowerCase(), parent.id];
    @let config =
      {
        outlets: isEvent
          ? {
              navigation: outletNavigation,
              content: ["event-markets", parent.id],
            }
          : {
              navigation: outletNavigation,
            },
      };
    <li class="parent">
      <a
        (click)="handleClick(parent)"
        [routerLink]="['/app/main', config]"
        [ngStyle]="{ 'font-weight': isImmediateParent($index) ? 700 : 400 }"
        [ngClass]="{ 'text-dark': true }"
        class="nav-link">
        <span>
          {{ parent?.name }}
        </span>
        <mat-icon>arrow_drop_up</mat-icon>
      </a>
    </li>
  }
  @for (item of navItems; track item) {
    @let isItemParent = ["EVENT", "RACE"].includes(item?.type);
    @let outletNavigation =
      item.type === "MARKET"
        ? [this.parents[this.parents.length - 1]?.type?.toLowerCase(), this.parents[this.parents.length - 1]?.id]
        : [item.type.toLowerCase(), item.id];
    @let config =
      {
        outlets: isViewableItem(item)
          ? {
              navigation: outletNavigation,
              content: isItemParent ? ["event-markets", item.id] : ["event-markets", this.parents[this.parents.length - 1]?.id, "market", item.id],
            }
          : {
              navigation: outletNavigation,
            },
      };
    @if ($loadingChildren | async) {
      <app-nav-item-loader [show]="true" />
    } @else {
      <li class="child">
        <a
          (click)="handleClick(item)"
          [routerLink]="['/app/main', config]"
          class="nav-link"
          [ngStyle]="{
            'font-weight': item.type === 'MARKET' && marketOps.isMarketSelected(item?.id) ? 800 : 400,
          }">
          <span class="nav-icon-text">
            @if (["MARKET", "EVENT", "RACE"].includes(item?.type)) {
              <mat-icon class="fav-icon" [class.selected-fav]="isFavorite(item)" (click)="handleFavorites(item, $event)">star</mat-icon>
            }
            <span class="nav-text" >
              @if (item?.startTime && showStartTime) {
                <span>{{ item?.startTime | date: "HH:mm" }}</span>
              }
              {{ item?.name }}
              @if (item.type === "RACE") {
                <span>({{ item?.countryCode }})</span>
              }
            </span>
          </span>
          @if (item?.type !== "MARKET") {
            <mat-icon class="drop-down-icon">arrow_drop_down</mat-icon>
          }
        </a>
      </li>
    }
  }
</ul>
